import React, { useState, useEffect, useContext, useMemo } from "react";
import axios from "axios";
import { useSelector } from "react-redux";
import Loader from "../CommonLoader";
import { Helmet } from 'react-helmet';
import { useNavigate } from 'react-router-dom';
import { Link, useParams } from "react-router-dom";
import Rightsidebar from "../Rightsidebar/Rightsidebar";
import QuestionMarkIcon from "@mui/icons-material/QuestionMark";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Button from "@mui/material/Button";
import { AppContext } from "../../../Context/Context";
import { Utils } from "../../../Utils/Utils";
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import Freeaudit from "../../../Utils/Freeaudit";
import CommonAlert from "../../../Commonalert/commonalert";
import ReportProblemIcon from '@mui/icons-material/ReportProblem';
import { Breadcrumbs, Typography } from "@mui/material";
import DatagridComp from "../DatagridComp";
import { CommonErrorAlert } from "../../../Commonalert/commonErrorAlert";
import CommonBreadCrumb from "../../../Commonalert/commonbreadcrumb";
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';
import Box from "@mui/material/Box";
import UserActivityTracker from "../../../hooks/userActivityTracker";


const PageLevelSetting = () => {

  const { isMenuExpanded, setIsMenuExpanded } = useContext(AppContext);
  const [cardData, setCardData] = useState([]);
  const rows = cardData ?? [];
  const [loading, setLoading] = useState(false);
  const esodata = useSelector((state) => state);
  const ApiToken = esodata.apiauthkey.value;
  const [PriorityOptions, SetPriorityOptions] = useState([])
  const [faqData, setfaqData] = useState("2")
  const [toggle, setToggle] = useState(false);
  const [initialfaqDateval, SetInitialfaqDateval] = useState([]);
  const [apiopen, setapiOpen] = React.useState(false);
  const [apierrorMsg, setapierrorMsg] = useState();
  const [pageLevelSettingPlan, setpageLevelSettingPlan] = useState({ status: true, error: "" });
  const [openCommonAlerts, setOpenCommonAlerts] = useState(false);
  const navigate = useNavigate();
  const [autoheightval, SetAutoheightval] = useState(true)
  const [first, setfirst] = useState({ name: "", path: "", closeName: "Close", statusDomain: false });
  const [checkD, setcheckD] = useState(false);
  const [domainNameUrl, setDomainNameUrl] = useState({ domain_name: '', domain_url: '' });
  const [tableLoading, setTableLoading] = useState(true);


  const columns = [

    {
      field: "issue_type",
      headerName: "Issue Type",
      description: 'Issue Type refers to the specific category or problem identified during a website audit, such as missing titles, H1 tags, or canonical links.',
      minWidth: 500,
      flex: 1,
      disableClickEventBubbling: true,
      headerAlign: "center",
      sortable: true,
      renderCell: (cardData) => {

        var ReturnString = '';
        ReturnString = cardData.row.issue_type

        ReturnString = ReturnString.replaceAll('_', ' ')

        const words = ReturnString.split(' ');;
        const capitalizedWords = words.map(word => {
          return word.charAt(0).toUpperCase() + word.slice(1);
        });
        return capitalizedWords.join(' ');
      }

    },
    {
      field: "priority",
      headerName: "Priority",
      description: 'SEO and Site parameters can be prioritized and categorized according to your organization’s marketing strategies',
      minWidth: 500,
      flex: 1,
      headerAlign: "center",
      align: "center",
      sortable: false,
      renderCell: (cardData) => {
        var DefaultValue = cardData.row.priority
        var Tag = cardData.row.issue_type
        return (
          <select style={{ border: "1px solid #ff601f" }} className="site_audit_settings_priority" onChange={(e) => { ChangeSettings(e, Tag) }}>

            {PriorityOptions.map(obj => {
              const key = Object.keys(obj)[0];
              const value = obj[key];
              return (<option key={value} value={value} selected={DefaultValue == value ? true : ''}>{key}</option>)
            })}



          </select>
        )

      }

    },
  ];

  const ChangeSettings = async (e, tag) => {
    setLoading(true)
    try {
      const datavalue = await axios.post(
        `${process.env.REACT_APP_API_URL}settings/Update_Pagelevel_Priority/${tag}/`, {
        user_domain_id: esodata.domaindata.value.header_selected,
        priority: e.target.value
      },
        {
          headers: {
            Authorization: `${ApiToken}`,
          },
        }
      ).catch((error) => {
        if (error?.response?.status == 599 || error?.response?.status == 400 || error?.response?.status == 500) {
          setapiOpen(true);
          setapierrorMsg(error?.response?.data?.error)
        }
        else if (error?.code == "ERR_NETWORK") {
          navigate('/errorpages')
        }
      });

      setLoading(false)

      if (datavalue?.data) {
        GetDefaultSettings()
      }

    } catch (err) {
      setLoading(false)
      console.log(err)
    }
  }

  const apihandleClose = () => {
    setapiOpen(false);
  };

  const GetDefaultSettings = async () => {
    setLoading(true);
    setTableLoading(true);
    setCardData([])
    try {
      const datavalue = await axios.get(
        `${process.env.REACT_APP_API_URL}settings/PageLevelSettings/?user_domain_id=${esodata.domaindata.value.header_selected}`,
        {
          headers: {
            Authorization: `${ApiToken}`,
          },
        }
      ).catch((error) => {
        if (error?.response?.status == 599 || error?.response?.status == 400 || error?.response?.status == 500) {
          setapiOpen(true);
          setapierrorMsg(error?.response?.data?.error)
        }
        else if (error?.code == "ERR_NETWORK") {
          navigate('/errorpages')
        }
      });
      if (datavalue?.data) {
        var FinalAObj = [];
        datavalue.data.forEach((element, index) => {
          var Obj = {};
          Obj.sid = index + 1;
          Obj.issue_type = element.issue_type
          Obj.priority = element.priority
          FinalAObj.push(Obj)
        });
        if (FinalAObj.length > 0) {
          SetAutoheightval(false)
          setCardData(FinalAObj)
        }
        else {
          SetAutoheightval(true)
        }
      }
    } catch (err) {
      console.log(err)
    }
    setTableLoading(false);
    setLoading(false)
  }

  const GetPriorityOptions = async () => {
    setLoading(true)
    SetPriorityOptions([])
    try {

      const datavalue = await axios.get(
        `${process.env.REACT_APP_API_URL}settings/top_action_severity_types/?user_domain_id=${esodata.domaindata.value.header_selected}`,
        {
          headers: {
            Authorization: `${ApiToken}`,
          },
        }
      ).catch((error) => {
        if (error?.response?.status == 599 || error?.response?.status == 400 || error?.response?.status == 500) {
          setapiOpen(true);
          setapierrorMsg(error?.response?.data?.error)
        }
        else if (error?.code == "ERR_NETWORK") {
          navigate('/errorpages')
        }
      });
      setLoading(false)

      if (datavalue?.data) {
        const outputArray = [];

        for (const key in datavalue.data) {
          if (datavalue.data.hasOwnProperty(key)) {
            outputArray.push({ [key]: datavalue.data[key] });
          }
        }
        SetPriorityOptions(outputArray)

      }

    } catch (err) {
      setLoading(false)
      console.log(err)
    }
  }

  const checkUserPlan = async () => {
    const pageLevelSettingP = await Utils("performance_settings", ApiToken);
    if (pageLevelSettingP.status) {
      GetDefaultSettings()
      GetPriorityOptions()
      faqdatafun()
    }
    setpageLevelSettingPlan(pageLevelSettingP);
  };

  useEffect(() => {
    checkUserPlan();
    GetuserDatavalue();
  }, [])

  const GetuserDatavalue = async () => {
    try {
      const datavalue = await axios.get(
        `${process.env.REACT_APP_API_URL}accounts/get_user_details/`,
        {
          headers: {
            Authorization: `${ApiToken}`,
          },
        }
      ).catch((error) => {

        if (error?.response?.status == 599 || error?.response?.status == 500 || error?.response?.status == 400 || error?.response?.status == 404) {
          navigate('/errorpages');
        }
        else if (error?.code == "ERR_NETWORK") {
          navigate('/errorpages');
        }
      });
      if (datavalue?.data?.dor_domain_name && datavalue?.data?.dor_domain_url) {
        setDomainNameUrl({ ...domainNameUrl, domain_name: datavalue?.data?.dor_domain_name, domain_url: datavalue?.data?.dor_domain_url });
      }
      if (datavalue?.data) {
        if (datavalue?.data?.is_location_required === true) {
          setfirst({ ...first, name: "Verify Now", path: "/Userdata", statusDomain: true });
          return
        }
        if (datavalue?.data?.is_domain_required === true) {
          setfirst({ ...first, name: "Verify Now", path: "/Impadddomain", statusDomain: true });
          return
        }
        if (datavalue?.data?.is_domain_ownership_required === true) {
          setfirst({ ...first, name: "Verify Now", path: "/Domainownership", statusDomain: true });
          return
        }

      }

    } catch (err) {
      console.log(err);
    }
  };


  const faqdatafun = async (menubutval = "") => {
    var datavar = `${process.env.REACT_APP_API_URL}domain/frequently_asked_questions/?menu=46`

    try {
      const doaminsectiondatavalue = await axios.get(
        datavar,
        {
          headers: {
            Authorization: `${ApiToken}`,
          },
        }
      ).catch((error) => {
        if (error?.response?.status == 599 || error?.response?.status == 400 || error?.response?.status == 500) {
          setapiOpen(true);
          setapierrorMsg(error?.response?.data?.error)
        }
        else if (error?.code == "ERR_NETWORK") {
          navigate('/errorpages')
        }
      });
      if (doaminsectiondatavalue?.data) {
        SetInitialfaqDateval(doaminsectiondatavalue?.data?.faqs)
      }
    } catch (err) { }
  }
  const handleToggle = () => {
    if (faqData != 1) {
      setfaqData(1)
    }
    else {
      setfaqData(2)
    }
    setToggle((pre) => !pre);
  };
  return (
    <>
      <Helmet>
        <meta charSet="utf-8" />
        <title>Page Level Settings</title>
      </Helmet>
      {
        loading === true ? <Loader /> : null
      }
      <div className={`over_all_container ${isMenuExpanded ? "blur overflow-hidden" : ""}`}>




        <Container maxWidth={false} className="dashboard-container">
          <Box className="dashboard-box">
            <Grid container className="dashboard-grid">
              <Grid item xs={12} md={4}>
                <div>
                  <h1 className="dashboard_header">
                    Page Level Settings
                    <span className="faq-chip" onClick={handleToggle}>FAQ's</span>
                  </h1>
                </div>
              </Grid>
              <Grid item xs={12} md={8}>
                <div className="top_breadcrumb_menu">
                  <div className="exportpdf_outer">
                    <div className="breadcrumb-wrapper">
                      <CommonBreadCrumb breadcrumbValue={[
                        { title: 'Settings' },
                        { title: 'Page Level Settings', activeColor: true }
                      ]} />
                    </div>
                  </div>
                </div>
              </Grid>
            </Grid>
          </Box>
        </Container>

        <Container maxWidth={false} className="dashboard-container">
          <Box className="dashboard-box-tab">
            <Grid container className="dashboard-grid">
              <Grid item xs={12} md={6}>

              </Grid>
              <Grid item xs={12} md={6}>
                <div className="drop_down_button" >
                  <Link to={first.statusDomain ? "#" : "/user-experience-setting"} onClick={first.statusDomain ? () => setcheckD(first.statusDomain) : null}><button type="button" className="btn_dashboard btn-non-active">User Experience Settings</button></Link>
                  <Link to={first.statusDomain ? "#" : "/page-level-setting"} onClick={first.statusDomain ? () => setcheckD(first.statusDomain) : null}><button type="button" className="btn_dashboard ">Page Level Settings</button></Link>
                </div>
              </Grid>
            </Grid>
          </Box>
        </Container>



        <Container maxWidth={false} className="dashboard-container">
          <Box className="grid_table_shodow">
            <Grid container className="dashboard-grid">
              <Grid item xs={12} md={12}>
                <div className="cnt_audit_outer_wrap">
                  {pageLevelSettingPlan.status ?
                    <DatagridComp
                      columns={columns}
                      rows={rows}
                      autoheightval={autoheightval}
                      datagridval={2}
                      tableLoading={tableLoading}
                    />
                    : <Freeaudit planStatus={pageLevelSettingPlan} />
                  }
                </div>
              </Grid>
            </Grid>
          </Box>
        </Container>

        <Container maxWidth={false} className="footer-container">
          <Box className="footer-box">
            <Grid container className="footer-grid">
              <Grid item xs={12} md={6}>
                <div className="footer-left">
                  <p className="footer-text">
                    All Rights Reserved Copyright © 2026 |
                    <a href="https://www.elitesiteoptimizer.ai/" target="_blank"> <span className="footer-brand"> Elite site Optimizer</span></a>
                  </p>
                </div>
              </Grid>
              <Grid item xs={12} md={6}>
                <div className="footer-right">
                  <p>{/* Add content if needed */}</p>
                </div>
              </Grid>
            </Grid>
          </Box>
        </Container>

        {toggle && <Rightsidebar close={() => setToggle(false)} setToggle={setToggle} initialfaqDateval={initialfaqDateval} />}

        <div className="cnt_audit_outer_wrap">
          {/* <div className="top_breadcrumb_menu">
            <CommonBreadCrumb breadcrumbValue={[
              { title: 'Settings' },
              { title: 'Page Level Settings', activeColor: true }
            ]} />
            <div className="exportpdf_outer">
              <button onClick={handleToggle} className="faq_class exportpdf" title="Frequently Asked Question" >
                <QuestionMarkIcon />

              </button>

            </div>
            {toggle && <Rightsidebar close={() => setToggle(false)} setToggle={setToggle} initialfaqDateval={initialfaqDateval} />}

          </div> */}
          {/* <div className="cnt_hdr_top_wraps">
            <div className="cnt_hdr_top_lft_wrap">
              <h2 className="heading_font"> Page Level Settings</h2>
            </div>
            <div className="cnt_hdr_top_rgt_wrap">
              <Link to={first.statusDomain ? "#" : "/user-experience-setting"} onClick={first.statusDomain ? () => setcheckD(first.statusDomain) : null}><button type="button" className={`site_rn_rpt_btn`} style={{ color: "#ff601f !important", width: 150, height: 37, padding: 8, lineHeight: 1.1 }}  >User Experience Settings</button></Link>
              <Link to={first.statusDomain ? "#" : "/page-level-setting"} onClick={first.statusDomain ? () => setcheckD(first.statusDomain) : null}><button type="button" className="site_rn_rpt_btn active runreportnew"   >Page Level Settings</button></Link>

            </div>

          </div>
          {pageLevelSettingPlan.status ?
            <DatagridComp
              columns={columns}
              rows={rows}
              autoheightval={autoheightval}
              datagridval={2}
              tableLoading={tableLoading}
            />
            : <Freeaudit planStatus={pageLevelSettingPlan} />
          } */}


          {!openCommonAlerts &&

            <CommonErrorAlert
              data={{
                apiopen: apiopen,
                apiErrorMsg: apierrorMsg,
                isIconStyled: true
              }}
              closeAlert={apihandleClose} />
          }


        </div>
      </div>
      <CommonAlert setOpenCommonAlerts={setOpenCommonAlerts} />

      <Dialog
        open={checkD}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        className="domain-verify-alert"
      >
        <DialogTitle className="keyword-dialog-header"><ReportProblemIcon fontSize="large" sx={{ color: '#ff601f' }} /></DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-slide-description">
            <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', gap: '15px', lineHeight: '1px', width: "max-content" }}>
              <p>{"Please verify your domain ("}<a href={domainNameUrl.domain_url} title={`go to this link ${domainNameUrl.domain_url}`} >{domainNameUrl.domain_name}</a>{") to access these features"}</p>
            </div>
          </DialogContentText>
        </DialogContent>
        <DialogActions className="dialog-action-button">
          <Button onClick={() => { navigate(first.path) }} >{first.name}</Button>
          <Button onClick={() => setcheckD(false)} >{first.closeName}</Button>
        </DialogActions>
      </Dialog>
      <UserActivityTracker pagename="Settings - Page Level Settings" />
    </>
  )
}
export default PageLevelSetting